<script>
import lazyLoadComponent from '@router/lazyload-component'
import {
  genderFilter,
  orderStatusFilter,
  orderPaymentMethodFilter,
  orderSourceFilter,
} from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'

export default {
  components: {
    BaseStateLabel: () =>
      lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    genderFilter,
    orderStatusFilter,
    orderPaymentMethodFilter,
    orderSourceFilter,
    formatDate,
  },
  data() {
    return {
      loading: false,
      orderInfo: {
        ordersCount: 0,
        prepaidOrdersCount: 0,
        totalSales: 0,
        orders: [],
      },
    }
  },
  created() {
    this.tryToFetchOrders()
  },
  methods: {
    async tryToFetchOrders() {
      this.loading = true
      this.orderInfo = await this.$store.dispatch('dashboard/fetchOrders')
      this.loading = false
    },
    redirectOrders() {
      this.$router.push({
        name: 'orders',
      })
    },
    tableRowClassName({ row }) {
      const rowStatus = row.status
      const usedStatus = row.groupSize / row.usedSize
      if (rowStatus === 0) return 'order--canceled'
      if (usedStatus === 1) return 'order--used'
    },
    async tryToFetchList() {
      this.orderInfo = await this.$store.dispatch('order/fetchList')
    },
  },
}
</script>

<template>
  <el-card class="box-card" shadow="never">
    <div slot="header">
      <el-row :gutter="15">
        <el-col :span="6">
          <el-button class="large-btn" type="primary" @click="redirectOrders"
            >查看訂單紀錄<BaseIcon name="file-invoice-dollar"
          /></el-button>
        </el-col>
        <el-col v-loading="loading" :span="6">
          <el-card class="card-statistics">
            <div class="card-statistics-info">
              <div class="card-statistics-title">近七日預定次數</div>
              <div class="card-statistics-count">{{
                orderInfo.ordersCount
              }}</div>
            </div>
            <el-avatar :size="50"> <BaseIcon name="flag" /> </el-avatar>
          </el-card>
        </el-col>
        <el-col v-loading="loading" :span="6">
          <el-card class="card-statistics">
            <div class="card-statistics-info"
              ><div class="card-statistics-title">預付方案銷售次數</div
              ><div class="card-statistics-count">{{
                orderInfo.prepaidOrdersCount
              }}</div></div
            >
            <el-avatar :size="50"> <BaseIcon name="piggy-bank" /> </el-avatar>
          </el-card>
        </el-col>
        <el-col v-loading="loading" :span="6">
          <el-card class="card-statistics">
            <div class="card-statistics-info"
              ><div class="card-statistics-title">近七日銷售總額</div
              ><div class="card-statistics-count"
                >${{ orderInfo.totalSales }}</div
              ></div
            >
            <el-avatar :size="50"> <BaseIcon name="dollar-sign" /> </el-avatar>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="header">
      <h3 class="block-title">
        最新預訂紀錄
      </h3>
    </div>

    <el-table
      v-loading="loading"
      element-loading-text="取得訂單資訊中"
      :data="orderInfo.orders"
      :default-sort="{ prop: 'created', order: 'descending' }"
      :row-class-name="tableRowClassName"
    >
      <el-table-column v-slot="{ row }" label="#訂單編號" width="220">
        <div>{{ `#${row.id}` }}</div>
        <div>{{ row.created | formatDate('dateTime') }}</div>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="狀態與來源" width="120">
        <BaseStateLabel :state="row.status | orderStatusFilter('color')" text>{{
          row.status | orderStatusFilter('text')
        }}</BaseStateLabel>
        <br />
        <BaseStateLabel state="info" text>{{
          row.source | orderSourceFilter
        }}</BaseStateLabel>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="付款方式" width="100">{{
        row.paymentMethod | orderPaymentMethodFilter
      }}</el-table-column>
      <el-table-column v-slot="{ row }" label="使用人資訊">
        <div>{{ row.fullName }} {{ row.gender | genderFilter }}</div>
        <div>{{ `${row.phoneCode} ${row.phoneNumber}` }}</div>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="訂購項目">
        <div>
          <b>{{ row.productName }}</b>
        </div>
        <div>{{ row.date | formatDate }} {{ row.time }}</div>
      </el-table-column>
    </el-table>
  </el-card>
</template>
